export function sanitizeTextWithOnlyNumbers(text) {
  const replacedText = text.replace(/\D/g, '').trim();

  return replacedText;
}

export function sanitizeTextWithOnlyAlphanumeric(text) {
  const replacedText = text.replace(/[^a-zA-Z0-9]+/g, '').trim();

  return replacedText;
}

export function sanitizeEmailAddress(email) {
  const replacedEmail = email.replace(/[^a-zA-Z0-9_/-@-.]/g, '').trim();

  return replacedEmail;
}
